module.exports = __webpack_public_path__ + "img/109.2c523893.jpg";